import { LOCALES } from 'i18n/locales';

export const enquiryWarningIntl = {
    [LOCALES.ENGLISH]: {
        'enquiryWarning.viewableWarning': 'This enquiry is viewable by other members of your organisation and supply chain.',
        'enquiryWarning.safetyLink': 'Please ensure all HSG47 safety protocols are followed.'
    },
    [LOCALES.WELSH]: {
        'enquiryWarning.viewableWarning': 'Gall aelodau eraill o\'ch sefydliad a\'ch cadwyn gyflenwi weld yr ymholiad hwn.',
        'enquiryWarning.safetyLink': 'Sicrhewch fod holl brotocolau diogelwch HSG47 yn cael eu dilyn.'
    }
};
